export function initSectionScroller() {
    $('.scrollToNextSection').click(function (e) {
        e.preventDefault();
        var $this = $(this),
            $next = $this.parent().next();
        $('html,body').animate({scrollTop: $next.offset().top}, 400);
    });
}